<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Hello World</h2>
    <ul>
      <li>
        <a
          href="https://blog.csdn.net/xy3233"
          target="_blank"
        >
          我的博客
        </a>
      </li>
    </ul>
    <button v-on:click="login">登录系统</button>
  </div>
</template>

<script>
  import { getUrlParam } from '../global/utils.js'
  import param  from '../global/global_params.js'
  export default {
    name: 'Index',
    data() {
      return {
        msg: '你好!'
      }
    },
    mounted()
    {
      let param = getUrlParam()
      if(param == null){
        return;
      }
      var accessToken = param.access_token;
      console.log("access_token: ",accessToken )
      if(accessToken == null){
        return;
      }
      var _this = this
      this.$axios
        .post('/login_by_token', {
          access_token: accessToken
        })
        .then(successResponse => {
          console.log("successResponse: ",successResponse)
          console.log(successResponse.data.code)
          if (successResponse.data.code === 200) {
            _this.$store.commit('login',successResponse.data.data)
            _this.$router.push({path: '/home'})
          }else {
            _this.$store.commit('logout')
            _this.$router.replace({path: '/index'})
          }
        })
        .catch(failResponse => {
          console.log(failResponse.toString())
        })
    }
     ,
    methods: {
      login() {
        console.log(param.getRandColor())
        console.log(param.token)
        this.$router.replace({path: '/login'})
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue